import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Alert } from "~/common/mui/Alert/Alert";
import parseTruncate from "~/common/utils/parseTruncate";
import { PopperTooltip } from "~/common/components/Tooltip";

interface Props {
  className?: string;
  preferredPackQuantity: number | null;
  packSize: number;
  quantity: number;
}

export const InfoOrderHandlingUnitQuantity = ({
  className,
  preferredPackQuantity = 0,
  packSize = 1,
  quantity = 0,
}: Props) => {
  const { t } = useTranslation();
  const fullfillmentRate = window.SCHA.config.qtyOptimizationFulfillmentRate / 100;

  if (!window.SCHA.feature.showOrderHandlingUnitQtySuggestion) {
    return null;
  }

  if (!preferredPackQuantity) {
    return null;
  }

  // Handles any number modulo 1 is always zero
  const reminder = packSize === 1 ? quantity : quantity % packSize;
  if (reminder === 0) {
    return null;
  }

  const value = reminder / preferredPackQuantity;
  const showAlert = fullfillmentRate <= value && value < 1.0;
  if (!showAlert) {
    return null;
  }

  const infoMsg = t("product.messages.orderHandlingUnitQuantity", {
    rate: fullfillmentRate * 100,
    pieces: preferredPackQuantity,
  });

  return (
    <Alert severity={"info"} className={classNames(className)}>
      <PopperTooltip tooltipContent={infoMsg} placement="bottom-start">
        {parseTruncate(infoMsg, 65, "...")}
      </PopperTooltip>
    </Alert>
  );
};
